import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CashLedgerTransaction } from '../../Models/Domains/Transactions/Cash/CashLedgerTransaction';

declare var IS_RUNNING_IN_APP_POOL;

export class CashLedgerTransactionWithBatchIdClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(transId: number): Promise<Array<CashLedgerTransaction>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/CashLedgerTransactionWithBatchId/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { transId: transId }

    return AjaxWrapper.get<Array<CashLedgerTransaction>, any>(url, data);
  }
}

